// GA4 analytics — Fionova.app funnel / conversion tracking.
//
// PRIVACY: only PRODUCT INTERACTIONS and FUNNEL STAGES are ever sent. NEVER send
// names, emails, passwords, journal/Unsaid/X-Ray/Plan/Future/Purpose/Ellie/
// Companion Memory content, book reasoning, card/payment details, or any
// free-form/sensitive user-generated text. Parameters here are static labels
// (step_name, step_number, plan, currency, value) only.
//
// Cross-domain: the shared property G-NPCLR0YS64 + GA Admin cross-domain config
// handle attribution and the _gl linker automatically. We never strip linker
// params. Enhanced conversions / user-provided data are NOT enabled.

import { useEffect } from "react";

export const GA_MEASUREMENT_ID = "G-NPCLR0YS64";

// Single non-sensitive pricing source for analytics (the authoritative charge
// remains Stripe). Used for begin_checkout / purchase value only.
export const FOUNDERS = { plan: "founders_monthly", currency: "USD", value: 9.99 };

const ready = () => typeof window !== "undefined" && typeof window.gtag === "function";

export function track(event, params = {}) {
  try { if (ready()) window.gtag("event", event, params); } catch {}
}

// Manual SPA page_view (config uses send_page_view:false so there is exactly one
// page_view per navigation and no duplicate initial hit).
export function trackPageView() {
  try {
    if (ready()) window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.search,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  } catch {}
}

// Fire at most once per browser tab session (guards SPA rerenders / refresh /
// back-navigation within a single onboarding journey; a genuinely new session
// can record the funnel again).
export function trackSessionOnce(key, event, params = {}) {
  try {
    const k = `ga_once_${key}`;
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
  } catch {}
  track(event, params);
}

// Major funnel exit (tab close / leave site). ref.current = { stage, ...static params } or null to skip.
export function useExitTracking(ref) {
  useEffect(() => {
    const onHide = () => {
      const p = ref.current;
      if (p && p.stage) trackSessionOnce(`exit_${p.stage}`, "funnel_exit", { ...p, transport_type: "beacon" });
    };
    window.addEventListener("pagehide", onHide);
    return () => window.removeEventListener("pagehide", onHide);
  }, [ref]);
}

// Fire at most once ever per unique key (used for purchase, keyed by the Stripe
// session id, so refreshes / revisits / webhook retries never double-count).
export function trackPersistentOnce(key, event, params = {}) {
  try {
    const k = `ga_done_${key}`;
    if (localStorage.getItem(k)) return;
    localStorage.setItem(k, "1");
  } catch {}
  track(event, params);
}
